export const pricesColorCoding = [
  { title: "Black", amount: 12000, short_hand: 12, color: "Black", bg: "bg-black" },
  { title: "Gray", amount: 10000, short_hand: 10, color: "Gray", bg: "bg-gray-500" },
  { title: "Green", amount: 9500, short_hand: 9.5, color: "Green", bg: "bg-green-500" },
  { title: "Blue", amount: 9000, short_hand: 9, color: "Blue", bg: "bg-blue-500" },
  { title: "Cyan", amount: 8500, short_hand: 8.5, color: "Cyan", bg: "bg-cyan-500" },
  { title: "Violet", amount: 8000, short_hand: 8, color: "Violet", bg: "bg-violet-500" },
  { title: "Silver", amount: 7500, short_hand: 7.5, color: "Silver", bg: "bg-gray-300" },
  { title: "Cream", amount: 7000, short_hand: 7, color: "Cream", bg: "bg-yellow-100" },
  { title: "Mauve", amount: 6500, short_hand: 6.5, color: "Mauve", bg: "bg-purple-200" },
  { title: "Peach", amount: 6000, short_hand: 6, color: "Peach", bg: "bg-orange-200" },
  { title: "Olive", amount: 5500, short_hand: 5.5, color: "Olive", bg: "bg-green-700" },
  { title: "Yellow", amount: 5000, short_hand: 5, color: "Yellow", bg: "bg-yellow-500" },
  { title: "Orange", amount: 4500, short_hand: 4.5, color: "Orange", bg: "bg-orange-500" },
  { title: "Pink", amount: 4200, short_hand: 4.2, color: "Pink", bg: "bg-pink-500" },
  { title: "Pink", amount: 4000, short_hand: 4, color: "Pink", bg: "bg-pink-500" },
  { title: "Purple", amount: 3500, short_hand: 3.5, color: "Purple", bg: "bg-purple-500" },
  { title: "Maroon", amount: 3000, short_hand: 3, color: "Maroon", bg: "bg-red-800" },
  { title: "Rust", amount: 2500, short_hand: 2.5, color: "Rust", bg: "bg-orange-700" },
  { title: "Red", amount: 2000, short_hand: 2, color: "Red", bg: "bg-red-500" },
  { title: "Brown", amount: 1000, short_hand: 1, color: "Brown", bg: "bg-amber-900" },
  { title: "FOC", amount: 0, short_hand: 0, color: "White", bg: "bg-white" },
];
